module.exports = __webpack_public_path__ + "static/img/logo-icmBio2.a61aec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-icmBio2.png
// module id = m0Ia
// module chunks = 11